import { render, staticRenderFns } from "./form.vue?vue&type=template&id=384dadb2&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384dadb2')) {
      api.createRecord('384dadb2', component.options)
    } else {
      api.reload('384dadb2', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=384dadb2&", function () {
      api.rerender('384dadb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/organization/form.vue"
export default component.exports